// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__29Ar6","container":"styles_container__2c4Ap","title":"styles_title__1lD3X","wrapper":"styles_wrapper__26suI","answer":"styles_answer__165Aj"};